import React, { useEffect, useState, useContext, useRef } from 'react';
import { Typography, Button, Box, Grid, CircularProgress, IconButton, Dialog, DialogContent, DialogTitle, Alert, Chip, Card, CardContent, Stack } from '@mui/material';
import Layout from '../../components/Layout';
import axios from 'axios';
import { AuthContext } from '../../AuthContext';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import '../../styles.css'; 

export default function Upgrade() {
    const { globalTenantId } = useContext(AuthContext);
    const [subscriptionPlan, setSubscriptionPlan] = useState(null);
    const globalTenantIdRef = useRef(globalTenantId);
    const [subscriptionInfoLoading, setSubscriptionInfoLoading] = useState(true);
    const [plans, setPlans] = useState(null);
    const [plansLoading, setPlansLoading] = useState(true);
    const [isAnnualSubscription, setIsAnnualSubscription] = useState(false);
    const [prices, setPrices] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [upgrading, setUpgrading] = useState(false);
    const navigate = useNavigate();
    const  Paddle  =  window.Paddle;
    const { user } = useContext(AuthContext);
    const [ip, setIP] = useState("");

    const isTrialing = subscriptionPlan?.paddleData?.status === 'trialing';
    const trialEndDate = subscriptionPlan?.paddleData?.next_billed_at
        ? new Date(subscriptionPlan.paddleData.next_billed_at).toLocaleDateString()
        : null;

    useEffect(() => { // get local pricing
        if (!plans) return;
        plans.forEach(async (plan) => {
            if (!plan.paddleDetails) return;
            const price = await getPrice(plan.paddleDetails.id);
            setPrices(prevPrices => ({ ...prevPrices, [plan.paddleDetails.id]: price }));
        });
    }, [plans]);
    
    const getIPAddress = async () => {
        const res = await axios.get("https://api.ipify.org/?format=json");
        setIP(res.data.ip);
      };
    
      useEffect(() => {
        getIPAddress();
      }, []);

    useEffect(() => {
        setPlansLoading(true);

        (async () => {
            if (Paddle) {
                const paddleEnv = (await axios.get('/api/setting?name=PADDLE_ENVIRONMENT')).data.value;
                const paddleAuth = (await axios.get('/api/setting?name=PADDLE_TOKEN')).data.value;
                                
                if (paddleEnv == 'sandbox') Paddle.Environment.set(paddleEnv);
                Paddle.Setup({
                    token: paddleAuth,
                    eventCallback: function(data) {
                        if (data.name == 'checkout.completed') {
                            checkoutComplete(data);
                        }
                    }
                });
    
            }
        })();

    }, []);

    useEffect(() => {
        globalTenantIdRef.current = globalTenantId;
    }, [globalTenantId]);
    

    const checkoutComplete = (data) => {

        setTimeout(() => {
            // get priceid from data.items[0].price_id
            let priceId = data.data.items[0].price_id;
            let transactionId = data.data.transaction_id;

            // call api/updateSubscription with priceId and transactionid
            updateSubscription(priceId, transactionId, true);
        }, 1000);

    }
    const fetchPlans = (isAnnual, trialEligible) => {
        // fetch plans
        axios.get('/api/plans', { params: { IsAnnual: isAnnual, tenantId: globalTenantId, freeTrialEligible: trialEligible } } )
        .then(result => {
            setPlans(result.data);
            setPlansLoading(false);

        }).catch(error => {
            console.error('Error fetching plans:', error);
        });
    }

    const updateSubscription = (priceId, transactionId) => {
        setUpgrading(true);
        axios.post('/api/updateSubscription', { paddleId: priceId, transactionId: transactionId })
            .then(result => {
                setUpgrading(false);

                // refresh sub info
                fetchSubscriptionData();
                navigate('/client-admin/', { state: { message: 'Subscription upgraded successfully!' } });


            }).catch(error => {
                console.error('Error updating subscription:', error);
            
                // Default error message
                let errorMessage = 'There was an error updating the subscription. Please try again.';
            
                // Check if the error response is structured
                if (error.response && error.response.data) {
                    if (typeof error.response.data === 'string') {
                        // If the response is a string, use it as the message
                        errorMessage = error.response.data;
                    } else if (error.response.data.message) {
                        // If the response is an object with a 'message' field, use it
                        errorMessage = error.response.data.message + '\n\n' + error.response.data.details;
                    }
                }
            
                // Display the error message
                // Consider using a more integrated UI element than alert for better user experience
                setErrorMessage(errorMessage);
                setShowAlert(true);
            
                // Set loading state to false, or perform other UI updates as needed
                setSubscriptionInfoLoading(false);
            });
            
    }

    const hideUpgradeError = () => {
        setUpgrading(false);
        setShowAlert(false);
        setErrorMessage('');
    }

    const myAccount = () => {
       navigate('/client-admin/my-account');
    }

    const openPaddleCheckout = async (paddleId) => {
        // upgrading an existing subscription or creating a new one?
        // if subscription exists, then we are upgrading
        if (subscriptionPlan.paddleData.items)
        {
            const confirmMessage = isTrialing
                ? `Are you sure you want to change your plan? Your free trial continues until ${trialEndDate} — you will not be charged until then.`
                : 'Are you sure you want to change your subscription? Doing so will automatically and immediately charge or credit depending on where you are in your billing cycle. If you are downgrading, any logs or movement snapshots will be automatically deleted based on the plan limitations.';
            if (!window.confirm(confirmMessage)) return;

            // existing subscription - upgrade
            updateSubscription(paddleId, null);

        }
        else
        {

            var itemsList = [
                {
                priceId: paddleId
                },
            ];
        
            Paddle.Checkout.open({
                settings: {
                    displayMode: "inline",
                    theme: "light",
                    locale: "en",
                    frameTarget: "checkout-container",
                    frameInitialHeight: "450",
                    frameStyle: "width: 100%; min-width: 312px; background-color: transparent; border: none;",
                    allowLogout: false,
                    showAddDiscounts: false,
                    showAddTaxId: false
                },
                items: itemsList,
                 customer:
                 {
                     email: user.email,
                 }
            });

            // Show the checkout overlay
            var overlay = document.querySelector('.checkout-overlay');
            overlay.style.display = 'flex';
        }
    };

    const handleCloseCheckout = () => {
        var overlay = document.querySelector('.checkout-overlay');
        overlay.style.display = 'none';
    }     

    const fetchPageData = () => {
        if (globalTenantId == null) return;
       
        fetchSubscriptionData();

    };

    const fetchSubscriptionData = () => {
        setSubscriptionInfoLoading(true);
        axios.get('/api/customer-subscription')
        .then(result => {
            const newPlan = JSON.parse(JSON.stringify(result.data));  // this must be done to force a re-render
            setSubscriptionPlan(newPlan);

            // Determine if the subscription is annual
            const isAnnual = result.data.paddleData.items && result.data.paddleData.items[0].price.billing_cycle.interval === 'year';
            setIsAnnualSubscription(isAnnual);
            fetchPlans(isAnnual, result.data.freeTrialEligible);

            setSubscriptionInfoLoading(false);

        }).catch(error => {
            console.error('Error fetching customer sub:', error);
        });
    }

    useEffect(() => {
        fetchPageData();
    }, [globalTenantId]); // An empty dependency array means this effect will run once after the initial render
    
    

    const getPrice = async (priceId) => {

        // either this is a new customer, or an existing customer upgrading
        // new customers will be based on IP address for pricing
        // existing customers will be based on their subscription/customer record

        let request = {
            items: [{
                priceId: priceId,
                quantity: 1
            }]
        };
    
        // Check if existing customer
        if (subscriptionPlan && subscriptionPlan.paddleData && subscriptionPlan.paddleData.items) {
            request.customerId = subscriptionPlan.paddleData.customer_id;
            request.addressId = subscriptionPlan.paddleData.address_id;
        } else {
            request.customerIpAddress = ip;
        }
        
        let result = await Paddle.PricePreview(request)
        let price = result.data.details.lineItems[0].formattedTotals.total;
        return price;
    }


    const formatTrialPeriod = (trialPeriod) => {
        if (!trialPeriod) return null;
        const { frequency, interval } = trialPeriod;
        return `${frequency} ${interval}${frequency > 1 ? 's' : ''}`;
    };

    const getBillingDateLabel = (plan) => {
        if (isTrialing) return `First payment: ${trialEndDate}`;
        const currentDate = new Date();
        const interval = plan.paddleDetails.billing_cycle.interval;
        let nextBilledDate = new Date(currentDate);
        if (interval === 'month') nextBilledDate.setMonth(currentDate.getMonth() + 1);
        else if (interval === 'year') nextBilledDate.setFullYear(currentDate.getFullYear() + 1);
        return `Renews on ${nextBilledDate.toLocaleDateString()}`;
    };

    return (
        <Layout title='Upgrade Entrinsic Connect'>
            { subscriptionInfoLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                    <CircularProgress size={40} />
                </Box>
            ) : (
                <>
                    {isTrialing && (
                        <Alert severity="info" sx={{ mb: 3, borderRadius: 2 }}>
                            You are on a free trial of <strong>{subscriptionPlan.plan.name}</strong>. Your trial ends on <strong>{trialEndDate}</strong> &mdash; you will not be charged until then.
                            You can switch to a different plan and your trial end date will remain the same.
                        </Alert>
                    )}

                    <Box sx={{ textAlign: 'center', mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                            {subscriptionPlan.paddleData.items
                                ? 'Change Your Plan'
                                : 'Choose the Right Plan for You'}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 520, mx: 'auto' }}>
                            {isTrialing
                                ? 'Switch plans freely during your trial. Your trial end date stays the same.'
                                : subscriptionPlan.paddleData.items
                                    ? 'Upgrade or downgrade at any time. We prorate charges automatically so you only pay the difference.'
                                    : 'Switch plan at any time without penalty.'}
                        </Typography>

                        <ToggleButtonGroup
                            value={isAnnualSubscription ? 'annual' : 'monthly'}
                            exclusive
                            onChange={(event, newAlignment) => {
                                if (!newAlignment) return;
                                const isAnnual = newAlignment === 'annual';
                                setIsAnnualSubscription(isAnnual);
                                fetchPlans(isAnnual, subscriptionPlan?.freeTrialEligible);
                            }}
                            aria-label="Subscription type"
                            sx={{
                                backgroundColor: '#f0f0f0',
                                borderRadius: '28px',
                                p: '3px',
                                '& .MuiToggleButtonGroup-grouped': {
                                    border: 0,
                                    borderRadius: '24px !important',
                                    px: 3,
                                    py: 0.75,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    fontSize: '0.9rem',
                                    '&.Mui-selected': {
                                        backgroundColor: '#fff',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
                                        color: '#1976d2',
                                        '&:hover': { backgroundColor: '#fff' },
                                    },
                                    '&:hover': { backgroundColor: 'transparent' },
                                },
                            }}
                        >
                            <ToggleButton value="monthly">Monthly</ToggleButton>
                            <ToggleButton value="annual">
                                Annual
                                <Chip label="Save" size="small" color="success" sx={{ ml: 1, height: 20, fontSize: '0.7rem' }} />
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>

                    {plansLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                            <CircularProgress size={30} />
                        </Box>
                    ) : (
                        <>
                            {/* Current plan summary */}
                            {plans.filter(p => subscriptionPlan.plan.PaddleID == p.PaddleID).map((plan) => {
                                const hasPaddle = !!plan.paddleDetails;
                                const trialLabel = hasPaddle ? formatTrialPeriod(plan.paddleDetails.trial_period) : null;
                                return (
                                    <Card
                                        key={plan.id || plan.PaddleID || plan.name}
                                        sx={{
                                            mb: 4,
                                            borderRadius: 3,
                                            border: '2px solid',
                                            borderColor: 'primary.main',
                                            backgroundColor: 'rgba(25,118,210,0.03)',
                                        }}
                                    >
                                        <CardContent sx={{ p: 3 }}>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" spacing={2}>
                                                <Box>
                                                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
                                                        <CheckCircleIcon color="primary" sx={{ fontSize: 20 }} />
                                                        <Typography variant="overline" color="primary" sx={{ fontWeight: 700, lineHeight: 1 }}>
                                                            {isTrialing ? 'Your Current Plan (Trial)' : 'Your Current Plan'}
                                                        </Typography>
                                                    </Stack>
                                                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                                        {plan.name}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                                        {plan.Details}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ textAlign: { xs: 'left', sm: 'right' }, flexShrink: 0 }}>
                                                    {hasPaddle ? (
                                                        <>
                                                            <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main', lineHeight: 1.2 }}>
                                                                {prices[plan.paddleDetails.id] || '...'}
                                                                <Typography variant="body2" component="span" color="text.secondary" sx={{ ml: 0.5, fontWeight: 400 }}>
                                                                    / {plan.paddleDetails.billing_cycle.interval}
                                                                </Typography>
                                                            </Typography>
                                                            {trialLabel && (
                                                                <Chip label={`${trialLabel} free trial`} size="small" color="success" variant="outlined" sx={{ mt: 1, fontWeight: 500 }} />
                                                            )}
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                                                {getBillingDateLabel(plan)}
                                                            </Typography>
                                                        </>
                                                    ) : (
                                                        <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.secondary' }}>Free</Typography>
                                                    )}
                                                </Box>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                );
                            })}

                            {/* Other available plans */}
                            {plans.filter(p => subscriptionPlan.plan.PaddleID != p.PaddleID).length > 0 && (
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: 'text.secondary' }}>
                                    {subscriptionPlan.paddleData.items ? 'Switch Plan' : 'Available Plans'}
                                </Typography>
                            )}
                            <Grid container spacing={3} justifyContent="flex-start" alignItems="stretch">
                                {plans.filter(p => subscriptionPlan.plan.PaddleID != p.PaddleID).map((plan) => {
                                    const hasPaddle = !!plan.paddleDetails;
                                    const trialLabel = hasPaddle ? formatTrialPeriod(plan.paddleDetails.trial_period) : null;

                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={plan.id || plan.PaddleID || plan.name}>
                                            <Card
                                                variant="outlined"
                                                sx={{
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    borderRadius: 3,
                                                    transition: 'box-shadow 0.2s, border-color 0.2s',
                                                    '&:hover': {
                                                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                                        borderColor: 'action.hover',
                                                    },
                                                }}
                                            >
                                                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                                        {plan.name}
                                                    </Typography>

                                                    {hasPaddle ? (
                                                        <Box sx={{ mb: 2 }}>
                                                            <Typography variant="h4" component="span" sx={{ fontWeight: 700, color: 'primary.main' }}>
                                                                {prices[plan.paddleDetails.id] || '...'}
                                                            </Typography>
                                                            <Typography variant="body2" component="span" color="text.secondary" sx={{ ml: 0.5 }}>
                                                                / {plan.paddleDetails.billing_cycle.interval}
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{ mb: 2 }}>
                                                            <Typography variant="h4" component="span" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                                                                Free
                                                            </Typography>
                                                        </Box>
                                                    )}

                                                    <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: 'wrap', gap: 0.5 }}>
                                                        {trialLabel && (
                                                            <Chip label={`${trialLabel} free trial`} size="small" color="success" variant="outlined" sx={{ fontWeight: 500 }} />
                                                        )}
                                                    </Stack>

                                                    {hasPaddle && (
                                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                                                            {getBillingDateLabel(plan)}
                                                        </Typography>
                                                    )}

                                                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                                                        {plan.Details}
                                                    </Typography>
                                                </CardContent>

                                                <Box sx={{ p: 3, pt: 0 }}>
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        onClick={() => openPaddleCheckout(plan.PaddleID)}
                                                        sx={{ borderRadius: 2, py: 1, textTransform: 'none', fontWeight: 600 }}
                                                    >
                                                        {subscriptionPlan.paddleData.items ? 'Switch to This Plan' : 'Get Started'}
                                                    </Button>
                                                </Box>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </>
                    )}

                    {subscriptionPlan.paddleData.items && (
                        <Box sx={{ textAlign: 'center', mt: 4 }}>
                            <Button
                                variant="text"
                                color="primary"
                                onClick={() => myAccount()}
                                sx={{ textTransform: 'none', fontWeight: 500 }}
                            >
                                Manage Account &amp; Billing
                            </Button>
                        </Box>
                    )}

                    <Dialog open={upgrading} PaperProps={{ sx: { borderRadius: 3, minWidth: 320 } }}>
                        <DialogTitle sx={{ fontWeight: 600 }}>Changing subscription...</DialogTitle>
                        <DialogContent>
                            {!showAlert && (
                                <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                                    <CircularProgress size={30} />
                                </Box>
                            )}
                            {showAlert && (
                                <Stack spacing={1}>
                                    {errorMessage.split("\n").map((line, index) => (
                                        <Typography key={index} variant="body1">{line}</Typography>
                                    ))}
                                    <Button
                                        variant="contained"
                                        onClick={() => hideUpgradeError()}
                                        sx={{ mt: 2, borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                                    >
                                        OK
                                    </Button>
                                </Stack>
                            )}
                        </DialogContent>
                    </Dialog>

                    <div className="checkout-overlay">
                        <IconButton className="close-button" onClick={handleCloseCheckout}>
                            <CloseIcon />
                        </IconButton>
                        <div className="checkout-container"></div>
                    </div>
                </>
            )}
        </Layout>
    );
}
